import { builder, isTodo } from './content';
import type { LandingCopy } from './copy';

const Text = ({ value }: { value: string }) =>
  isTodo(value) ? <span className="lp-todo">{value}</span> : <>{value}</>;

/** A TODO never becomes a dead link — it renders as a marked placeholder until it's a real URL. */
const ProfileLink = ({ label, href }: { label: string; href: string }) =>
  isTodo(href) ? (
    <span className="lp-todo">
      {label} — {href}
    </span>
  ) : (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="lp-btn lp-btn--small lp-btn--outline"
    >
      {label}
    </a>
  );

/** What Order Bot is and who is behind it. */
export const About = ({ copy }: { copy: LandingCopy['about'] }) => (
  <section id="about" className="lp-section">
    <div className="lp-container lp-builder">
      <h2>{copy.title}</h2>
      {copy.body.map((para) => (
        <p key={para} className="lp-section__intro">
          {para}
        </p>
      ))}
      <h3 className="lp-builder__heading">{copy.builderTitle}</h3>
      <p className="lp-builder__name">
        <Text value={builder.name} />
      </p>
      <p className="lp-builder__blurb">
        <Text value={copy.blurb} />
      </p>
      <div className="lp-builder__links">
        <ProfileLink label="GitHub" href={builder.github} />
        <ProfileLink label="LinkedIn" href={builder.linkedin} />
      </div>
    </div>
  </section>
);
